import React from 'react';

const ToggleButton = ({
  isActive,
  onToggle,
  activeText,
  activeCalculation,
  ToggleIcon,
  hidden,
  inactiveText,
  testId
}) => {
  const hiddenClass = hidden ? 'hidden' : '';
  const activeClass = isActive ? `${activeCalculation ? "bg-primary" : "bg-blue-500"} text-white` : 'bg-gray-200 text-gray-700';
  const activeIconClass = isActive ? "text-white" : "text-gray-700";
  return (
    <button
      onClick={onToggle}
      data-testid={testId}
      className={`flex flex-row gap-2 items-center px-4 py-2 rounded transition-colors duration-200 ${hiddenClass} ${activeClass}`}
    >
      {isActive ? activeText : inactiveText}
      {ToggleIcon && <ToggleIcon className={`h-5 w-5 ${activeIconClass}`} />}
    </button>
  );
};

export default ToggleButton; 